export const messages = {
  en: {
    menuGroupManage: {
      queryCondition: 'Query Conditions',
      enterMenuGroupName: 'Please enter menu group name',
      selectLabel: 'Please select label',
      selectStoreType: 'Please select store type',
      query: 'Query',
      reset: 'Reset',
      menuGroup: 'Menu Group',
      add: 'Add',
      menuGroupId: 'Menu Group ID',
      menuGroupName: 'Menu Group Name',
      menuGroupType: 'Menu Group Type',
      storeType: 'Store Type',
      icon: 'Icon',
      label: 'Label',
      sequence: 'Sequence',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      operationTeam: 'Operation Team',
      merchant: 'Merchant',
      developmentTeam: 'Development Team',
      unknown: 'Unknown'
    },
    addMenuGroup: {
      addMenuGroup: 'Add Menu Group',
      groupName: 'Group Name',
      requiredGroupName: 'Required, please enter group name',
      icon: 'Icon',
      requiredIcon: 'Required, please enter icon',
      label: 'Label',
      optionalLabel: 'Optional, please select label',
      sequence: 'Sequence',
      requiredSequence: 'Required, please enter sequence',
      groupType: 'Group Type',
      optionalGroupType: 'Optional, please select group type',
      storeType: 'Store Type',
      selectStoreType: 'Please select store type',
      description: 'Description',
      optionalDescription: 'Optional, please enter description',
      cancel: 'Cancel',
      save: 'Save',
      groupNameRequired: 'Group name is required',
      groupNameLength: 'Group name must be between 2-10 characters',
      iconRequired: 'Icon is required',
      iconLength: 'Icon must be between 2-20 characters',
      sequenceRequired: 'Sequence is required',
      sequenceNumber: 'Sequence must be a number',
      addSuccess: 'Add successfully',
      addFailed: 'Add failed',
      web: 'WEB',
      app: 'APP'
    },
    editMenuGroup: {
      editMenuGroup: 'Edit Menu Group',
      groupName: 'Group Name',
      requiredGroupName: 'Required, please enter group name',
      icon: 'Icon',
      requiredIcon: 'Required, please enter icon',
      label: 'Label',
      optionalLabel: 'Optional, please select label',
      sequence: 'Sequence',
      requiredSequence: 'Required, please enter sequence',
      groupType: 'Group Type',
      optionalGroupType: 'Optional, please select group type',
      storeType: 'Store Type',
      selectStoreType: 'Please select store type',
      description: 'Description',
      optionalDescription: 'Optional, please enter description',
      cancel: 'Cancel',
      save: 'Save',
      groupNameRequired: 'Group name is required',
      groupNameLength: 'Group name must be between 2-10 characters',
      iconRequired: 'Icon is required',
      iconLength: 'Icon must be between 2-20 characters',
      sequenceRequired: 'Sequence is required',
      sequenceNumber: 'Sequence must be a number',
      groupIdRequired: 'Group ID is required',
      editSuccess: 'Edit successfully',
      editFailed: 'Edit failed',
      web: 'WEB',
      app: 'APP'
    },
    deleteMenuGroup: {
      confirmOperation: 'Please confirm your operation',
      confirmDeleteMenuGroup: 'Confirm to delete menu group',
      cancel: 'Cancel',
      confirmDelete: 'Confirm Delete',
      deleteSuccess: 'Delete successfully',
      deleteFailed: 'Delete failed'
    }
  },
  zh: {
    menuGroupManage: {
      queryCondition: '查询条件',
      enterMenuGroupName: '请输入菜单组名称',
      selectLabel: '请选择标签',
      selectStoreType: '请选择归属商户',
      query: '查询',
      reset: '重置',
      menuGroup: '菜单组',
      add: '添加',
      menuGroupId: '菜单组Id',
      menuGroupName: '菜单组名称',
      menuGroupType: '菜单组类型',
      storeType: '归属商户',
      icon: '图标',
      label: '标签',
      sequence: '序列',
      operation: '操作',
      edit: '修改',
      delete: '删除',
      operationTeam: '运营团队',
      merchant: '商家',
      developmentTeam: '开发团队',
      unknown: '未知'
    },
    addMenuGroup: {
      addMenuGroup: '添加菜单组',
      groupName: '组名称',
      requiredGroupName: '必填，请填写组名称',
      icon: '图标',
      requiredIcon: '必填，请填写图标',
      label: '标签',
      optionalLabel: '选填，请选择标签',
      sequence: '序列',
      requiredSequence: '必填，请填写序列',
      groupType: '组类型',
      optionalGroupType: '选填，请选择组类型',
      storeType: '归属商户',
      selectStoreType: '请选择商户类型',
      description: '描述',
      optionalDescription: '选填，请填写描述',
      cancel: '取消',
      save: '保存',
      groupNameRequired: '组名称不能为空',
      groupNameLength: '组名称必须在2至10字符之间',
      iconRequired: '图标不能为空',
      iconLength: '图标必须在2至20字符之间',
      sequenceRequired: '序列不能为空',
      sequenceNumber: '序列必须为整数',
      addSuccess: '添加成功',
      addFailed: '添加失败',
      web: 'WEB端',
      app: 'APP端'
    },
    editMenuGroup: {
      editMenuGroup: '修改菜单组',
      groupName: '组名称',
      requiredGroupName: '必填，请填写组名称',
      icon: '图标',
      requiredIcon: '必填，请填写图标',
      label: '标签',
      optionalLabel: '选填，请选择标签',
      sequence: '序列',
      requiredSequence: '必填，请填写序列',
      groupType: '组类型',
      optionalGroupType: '选填，请选择组类型',
      storeType: '归属商户',
      selectStoreType: '请选择商户类型',
      description: '描述',
      optionalDescription: '选填，请填写描述',
      cancel: '取消',
      save: '保存',
      groupNameRequired: '组名称不能为空',
      groupNameLength: '组名称必须在2至10字符之间',
      iconRequired: '图标不能为空',
      iconLength: '图标必须在2至20字符之间',
      sequenceRequired: '序列不能为空',
      sequenceNumber: '序列必须为整数',
      groupIdRequired: '组Id不能为空',
      editSuccess: '修改成功',
      editFailed: '修改失败',
      web: 'WEB端',
      app: 'APP端'
    },
    deleteMenuGroup: {
      confirmOperation: '请确认您的操作',
      confirmDeleteMenuGroup: '确定删除菜单组',
      cancel: '点错了',
      confirmDelete: '确认删除',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败'
    }
  }
}